import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMAS,
  DELETE_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA,
} from "api";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { useStyles as useStylesContentList } from "ui/styles/contentList";
import DownloadButton from "components/DownloadButton";
import DiplomaTemplate from "containers/Templates/LanguageRepresentativeEducatorDiploma";
import { getFileName } from "services/Utils";

const LanguageRepresentativeEducatorDiplomas: React.FC = (props) => {
  let navigate = useNavigate();
  const classesContentList = useStylesContentList();

  const editItem = (id = "skapa") => {
    navigate(`/diplom-sprakombudsutbildare/${id}`);
  };

  const getActionButtons = () => {
    let buttons = [];
    if (
      VoAuth.ability.can(
        "update_own_language_representative_educator_diplomas",
        "Cert"
      )
    ) {
      buttons.push("edit");
    }
    if (
      VoAuth.ability.can(
        "delete_own_language_representative_educator_diplomas",
        "Cert"
      )
    ) {
      buttons.push("delete");
    }
    return buttons;
  };

  const getCustomActionButtons = (row: any) => {
    return (
      <>
        <DownloadButton
          auditResource={{ resourceType: "LanguageRepresentativeEducatorDiploma", id: String(row.id) }}
          className={classesContentList.actionButton}
          document={<DiplomaTemplate item={row} />}
          fileName={`${getFileName([
            row && row.firstname,
            row && row.lastname,
          ])}.pdf`}
        />
      </>
    );
  };

  return (
    <Layout>
      <EnhancedTable
        enableSearch
        className="vo-global__top-bottom-space"
        title={
          I18n.get.languageRepresentativeEducatorDiploma.labels
            .languageRepresentativeEducatorDiplomas
        }
        operations={{
          category: "certLanguageRepresentativeEducatorDiplomas",
          get: GET_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMAS,
          delete: DELETE_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA,
        }}
        labels={{
          deleted:
            I18n.get.languageRepresentativeEducatorDiploma.messages
              .languageRepresentativeDiplomaDeleted,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.user.labels.firstname, field: "firstname" },
          { title: I18n.get.user.labels.lastname, field: "lastname" },
          {
            title: I18n.get.languageRepresentativeDiploma.labels.place,
            field: "place",
            width: 200,
          },
          {
            title: I18n.get.vocertCourseMoment.label,
            field: "course_moment",
            width: 200,
            render: (data) => data.course_moment && data.course_moment.title,
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
        ]}
        addItem={
          VoAuth.ability.can(
            "create_own_language_representative_educator_diplomas",
            "Cert"
          )
            ? editItem
            : undefined
        }
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        actionButtons={getActionButtons()}
        renderActionButtons={getCustomActionButtons}
      />
    </Layout>
  );
};

export default LanguageRepresentativeEducatorDiplomas;
